module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
 var listService = require('ListService').default;
 var util = require('util/Util.js').default;

    ; __append("\r\n<div class=\"block\">\r\n    <h2 id=\"test\">Service Details</h2>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-3\">\r\n            <span>Service URL</span>\r\n        </div>\r\n        <div class=\"col-sm-9\">\r\n            ")
    ;  

            var isBULicense = util.isTrue(listService.accountSettings.IsBULicense);
            if(isBULicense){ 
                var cURL = currentConnectionDetails.ConnectionXML.Connection['_url'];
                var urlEmpty = !cURL || cURL === '' || cURL === 'undefined';

                var inCatalog = wsSources.find(function(source) {return source['@Source'] === cURL});
                var showError = !inCatalog && (!currentConnectionDetails.WSSourceId && !urlEmpty);
                var showAlert = inCatalog && !currentConnectionDetails.WSSourceId;
               
                
    ; __append("   \r\n                <div style=\"color:red; margin:2px;display:")
    ; __append(escapeFn(showError ? 'block' : 'none'))
    ; __append("\">                          \r\n                    The connection URL is not listed in the REST/SOAP Service URL catalog. To ensure the connection works, please add the source to the catalog in Settings > Resources.  \r\n            </div>   \r\n            <div style=\"color:red; margin:2px;display:")
    ; __append(escapeFn(showAlert ? 'block' : 'none'))
    ; __append("\">                          \r\n                The connection URL is not currently linked to the Service URL catalog. Click 'Apply Changes' to establish the association.  \r\n        </div>  \r\n                <div class=\"col-sm-11\" style=\"margin: 0;padding: 0;\">\r\n                    <select name=\"wsSources\" id=\"wsSources\">\r\n                        <option value=\"null\"></option>\r\n                        ")
    ;  for (var i = 0; i < wsSources.length; i++) {
                            var sourceURL = wsSources[i]['@Source'].trim();
                            
    ; __append("\r\n                            <option value=\"")
    ; __append(escapeFn(wsSources[i]['@WsSourceId'] ))
    ; __append("\"  ")
    ; __append(escapeFn(selectedSource === wsSources[i]['@WsSourceId'] || currentConnectionDetails.ConnectionXML.Connection['_url'] === sourceURL ? 'selected="selected"' :''))
    ; __append(" >")
    ; __append(escapeFn(sourceURL))
    ; __append("</option>\r\n                                    \r\n                        ")
    ;  }; 

                        if(showError){ 
    ; __append("\r\n                            <option value=\"")
    ; __append(escapeFn(currentConnectionDetails.ConnectionXML.Connection['_url'] ))
    ; __append("\" selected=\"selected\"> ")
    ; __append(escapeFn(currentConnectionDetails.ConnectionXML.Connection['_url'] ))
    ; __append("</option>\r\n                        ")
    ;  
                            }
                        
    ; __append("\r\n\r\n                    </select>\r\n                </div>\r\n                <div class=\"col-sm-1\" style=\"padding: 0; padding-left: 1vw;\">  \r\n                    <i class=\" fa pf-refresh-report refresh-wssource\" style=\"font-size: 24px;\"></i>\r\n                </div>\r\n            ")
    ;  } 
    ; __append("\r\n\r\n            <input type=\"text\" class=\"connection\" style=\"display:")
    ; __append(escapeFn( isBULicense ? 'none' : 'block' ))
    ; __append("\" id=\"_url\" name=\"_url\" value=\"")
    ; __append(escapeFn( currentConnectionDetails.ConnectionXML.Connection['_url'] ))
    ; __append("\"/>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-3\">\r\n            <span>Basic Auth</span>\r\n        </div>\r\n        <div class=\"col-sm-9\">\r\n            <div class=\"col-sm-7 nopadding-l\">\r\n                <input type=\"text\" class=\"margin-right:10px;\" placeholder=\"Username\" name=\"_username\" autocomplete=\"false\" value=\"")
    ; __append(escapeFn( currentConnectionDetails.ConnectionXML.Connection['_username'] ))
    ; __append("\"/>\r\n            </div>\r\n            <div class=\"col-sm-5\" style=\"padding:0;\">\r\n                <input type=\"password\" name=\"_password\" autocomplete=\"new-password\" placeholder=\"Password\" value=\"")
    ; __append(escapeFn( currentConnectionDetails.ConnectionXML.Connection['_password'] ))
    ; __append("\"/>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-3\">\r\n            <span>Certificate</span>\r\n        </div>\r\n        <div class=\"col-sm-9\">\r\n            <div class=\"col-sm-7 nopadding-l\">\r\n                <div class=\"col-md-9\" style=\"padding: 0\">\r\n                    <input type=\"text\" disabled id=\"CertificateName\"  value=\"")
    ; __append(escapeFn( currentConnectionDetails.CertificateName ))
    ; __append("\" style=\"margin-top: 0;\">\r\n                </div>\r\n                <div class=\"col-md-3\" style=\"padding: 0;padding-left: 5px;\">\r\n                    ")
    ;  if(!currentConnectionDetails.CertificateName || currentConnectionDetails.CertificateName === '' || typeof currentConnectionDetails.CertificateName === 'undefined'){ 
    ; __append("\r\n                    <div id='cert-upload-button' class=\"btn btn-default browse-button\">\r\n\r\n                       <label id=\"file-upload-label\" for=\"cert-file-upload\">Browse</label>\r\n                       <input type=\"file\" name=\"CertificateName\" id=\"cert-file-upload\" class=\"inputfile\" accept=\".pfx,.cer,.crt,.p12\">\r\n                    </div>\r\n                    ")
    ; } else{ 
    ; __append("\r\n\r\n                        <div id='remove-file' class=\"btn btn-default browse-button\">\r\n                            <label id=\"cert-file-upload-label\" class=\"file-upload-label\" for=\"cert-file-upload\">Remove</label>                           \r\n                         </div>\r\n                    ")
    ;  } 
    ; __append("\r\n                </div>\r\n            </div>\r\n            <div class=\"col-sm-5\" style=\"padding:0;\">\r\n                <input type=\"password\" name=\"CertificatePassphrase\" id=\"CertificatePassphrase\" placeholder=\"Passphrase\" value=\"")
    ; __append(escapeFn( currentConnectionDetails.CertificatePassphrase ))
    ; __append("\"/>\r\n            </div>\r\n        </div>\r\n        ")
    ;  if(currentConnectionDetails.CertificateExpiresOn && currentConnectionDetails.CertificateExpiresOn !== '' && typeof currentConnectionDetails.CertificateExpiresOn !== 'undefined'){ 
       
            
    ; __append("\r\n        <div class=\"col-sm-3\"></div>\r\n            <div class=\"col-sm-9\">\r\n               <div style=\"padding: 3px 2px;; font-weight: 600;\" class=\"certificateDate ")
    ; __append(escapeFn( expired ))
    ; __append("\">Expires On: ")
    ; __append(escapeFn( currentConnectionDetails.CertificateExpiresOn ))
    ; __append("</div>\r\n            </div>\r\n        </div>\r\n        ")
    ;  } 
    ; __append("\r\n    </div>\r\n\r\n    \r\n</div>\r\n\r\n<div id=\"alertModal\" title=\"\" style=\"display: none;\"></div>\r\n")
  }
  return __output;

}